export const FilterIcon = ({ fill = '#92929D' }: { fill?: string }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5ZM7 9C7 8.44772 7.44772 8 8 8C8.55228 8 9 8.44772 9 9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9ZM10.4187 15.5309L8.92699 16.9688V11.8934C8.92699 11.402 8.50988 11 8.00008 11C7.49028 11 7.07317 11.402 7.07317 11.8934V16.9688L5.58146 15.5309C5.22059 15.1831 4.63107 15.1831 4.27019 15.5309C3.90994 15.8782 3.90994 16.4464 4.27019 16.7942L7.32899 19.742C7.51314 19.92 7.75723 20.004 8.00008 19.9999C8.24293 20.004 8.48701 19.92 8.67116 19.742L11.7293 16.7942C12.0902 16.4464 12.0902 15.8782 11.7293 15.5309C11.3691 15.1831 10.7796 15.1831 10.4187 15.5309Z"
            fill="black"
        />
        <mask
            id="mask0_757_8488"
            maskUnits="userSpaceOnUse"
            x="4"
            y="5"
            width="8"
            height="15"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5ZM7 9C7 8.44772 7.44772 8 8 8C8.55228 8 9 8.44772 9 9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9ZM10.4187 15.5309L8.92699 16.9688V11.8934C8.92699 11.402 8.50988 11 8.00008 11C7.49028 11 7.07317 11.402 7.07317 11.8934V16.9688L5.58146 15.5309C5.22059 15.1831 4.63107 15.1831 4.27019 15.5309C3.90994 15.8782 3.90994 16.4464 4.27019 16.7942L7.32899 19.742C7.51314 19.92 7.75723 20.004 8.00008 19.9999C8.24293 20.004 8.48701 19.92 8.67116 19.742L11.7293 16.7942C12.0902 16.4464 12.0902 15.8782 11.7293 15.5309C11.3691 15.1831 10.7796 15.1831 10.4187 15.5309Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0_757_8488)">
            <rect x="1" y="-1" width="24" height="24" fill={fill} />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 20C15.4477 20 15 19.5523 15 19C15 18.4477 15.4477 18 16 18C16.5523 18 17 18.4477 17 19C17 19.5523 16.5523 20 16 20ZM15 16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15C15.4477 15 15 15.4477 15 16ZM18.4187 9.46906L16.927 8.03124V13.1066C16.927 13.598 16.5099 14 16.0001 14C15.4903 14 15.0732 13.598 15.0732 13.1066V8.03124L13.5815 9.46906C13.2206 9.8169 12.6311 9.8169 12.2702 9.46906C11.9099 9.12182 11.9099 8.5536 12.2702 8.20576L15.329 5.25805C15.5131 5.07996 15.7572 4.99598 16.0001 5.00015C16.2429 4.99598 16.487 5.07996 16.6712 5.25805L19.7293 8.20576C20.0902 8.5536 20.0902 9.12182 19.7293 9.46906C19.3691 9.8169 18.7796 9.8169 18.4187 9.46906Z"
            fill="black"
        />
        <mask
            id="mask1_757_8488"
            maskUnits="userSpaceOnUse"
            x="12"
            y="5"
            width="8"
            height="15"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 20C15.4477 20 15 19.5523 15 19C15 18.4477 15.4477 18 16 18C16.5523 18 17 18.4477 17 19C17 19.5523 16.5523 20 16 20ZM15 16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15C15.4477 15 15 15.4477 15 16ZM18.4187 9.46906L16.927 8.03124V13.1066C16.927 13.598 16.5099 14 16.0001 14C15.4903 14 15.0732 13.598 15.0732 13.1066V8.03124L13.5815 9.46906C13.2206 9.8169 12.6311 9.8169 12.2702 9.46906C11.9099 9.12182 11.9099 8.5536 12.2702 8.20576L15.329 5.25805C15.5131 5.07996 15.7572 4.99598 16.0001 5.00015C16.2429 4.99598 16.487 5.07996 16.6712 5.25805L19.7293 8.20576C20.0902 8.5536 20.0902 9.12182 19.7293 9.46906C19.3691 9.8169 18.7796 9.8169 18.4187 9.46906Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask1_757_8488)">
            <rect
                width="24"
                height="24"
                transform="matrix(1 0 0 -1 -1 25)"
                fill={fill}
            />
        </g>
    </svg>
)
